/**
 * How a study's audience is named in a one-line summary (studies list, chat header).
 *
 * Backend labels arrive as "Cereal: Protein Purists". One selection reads well in
 * full. But someone can pick ten archetypes, and concatenating them all produced a
 * line long enough to wrap into (and collide with) whatever sits beside it — so a
 * multi-selection collapses to "Multiple profiles" rather than an unbounded list.
 * The full breakdown still lives on the study's review and results.
 */
export const MULTI_PROFILE_LABEL = 'Multiple profiles';

/** "Cereal › Protein Purists" — or "Multiple profiles" once there's more than one. */
export function audienceSummary(labels?: string[] | null): string | null {
  if (!labels || labels.length === 0) return null;
  if (labels.length > 1) return MULTI_PROFILE_LABEL;
  const [only] = labels;
  return only.includes(': ') ? only.replace(': ', ' › ') : only;
}
